import { PlanCardFace, PlanTypes } from '../../../../shared/utils/interfaces/planInterface'
import { Button } from 'antd'
// import PriceTag from '../../../../shared/components/Typography/PriceTag' // for demo only
import IconTextList from '../../../../shared/components/Typography/IconTextList'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../authentication/slice/authSlice'
import { useNavigate } from 'react-router-dom'
import { selectIsLoadingCurrentPlan, setPlansModalOpen } from '../../slice/settingsSlice'
import { setIsThanksModalOpen } from '../../../ContactUsForm/slice/contactusSlice'
import { useLogContactSalesPlanMutation } from '../../slice/createSettingApiSlice'

export default function PlanCard({ plan: { name, price, benefits, id }, handleSubscribe, publicView, selectedPlanId }: PlanCardFace) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const currentPlan = useSelector(selectCurrentUser)?.plan;
  const isLoadingCurrentPlan = useSelector(selectIsLoadingCurrentPlan)
  const [logContactSalesPlan] = useLogContactSalesPlanMutation()

  return (
    <div className='bg-white border border-gray-200 rounded-lg shadow-sm text-start'>
      <div className='p-6 border-b border-gray-200'>
        <h3 className='mb-3 text-lg font-medium text-gray-900'>{name}</h3>
        {/* <PriceTag price={price} /> //for demo only */}
        <Button
          loading={isLoadingCurrentPlan && selectedPlanId === id}
          disabled={(currentPlan?.id === id && !publicView) || isLoadingCurrentPlan}
          className={`${(currentPlan?.id === id && !publicView) ? 'cursor-not-allowed' : (!publicView && id === PlanTypes.free) ? '!cursor-default' : id === PlanTypes.free && !publicView ? 'btn-primary-light' : 'btn-primary !cursor-pointer'} btn-md w-full`}
          // onClick={publicView ? () => navigate('/login') : handleSubscribe}
          onClick={publicView ? () => navigate('/signup') : async () => {
            dispatch(setPlansModalOpen(false));
            dispatch(setIsThanksModalOpen(true))
            await logContactSalesPlan({ planId: id })
          }} // for demo only
        >
          {/* {(currentPlan?.id === id && !publicView) ? 'Your Current Plan' : (publicView && id === PlanTypes.free) ? 'Subscribe Now' : id === PlanTypes.free ? `Downgrade to ${name}` : `Upgrade to ${name}`} */}
          {(currentPlan?.id === id && !publicView) ? 'Your Current Plan' : (publicView && id === PlanTypes.free) ? 'Subscribe Now' : id === PlanTypes.free ? `Downgrade to ${name}` : `Contact Sales`} {/* for demo only */}
        </Button>
      </div>
      <div className='p-6'>
        <p className='mt-2 mb-5 text-sm font-medium text-gray-900'>What's included</p>
        <IconTextList items={benefits?.map((benefit: string) => { return { text: benefit } })} />
      </div>
    </div>
  )
}
